import * as VOXLib from 'voximplant-websdk';
import type { Call } from 'voximplant-websdk/Call/Call';

/**
 * Уровни таймера на стороне vox вида
 * чем меньше уровень - тем меньше осталось времени у конференции
 * эти уровни используются, например, для окрашивания таймера / для вывода предупреждения
 * */
export enum TimerLevel {
    ONE = 1,
    TWO = 2,
}

/**
 * Конфигурация таймера на стороне vox вида
 *
 * `{ УРОВЕНЬ_ТАЙМЕРА: КОЛИЧЕСТВО_МИЛЛИСЕКУНД }`
 *
 * */
export type TimerConfig = Record<TimerLevel, number>;

interface Params {
    setAvailableTime: (amount: number) => void;
    setElapsedTime: (amount: number) => void;
    setNotification: (amount: number) => void;
    setTimerConfig: (config: TimerConfig) => void;
    voxCall: Call;
}

interface ParsedTimerMessage {
    elapsedTime?: number;
    remaining?: number;
    timerLevels: TimerConfig;
    warning?: boolean;
}

/** Установить слушатель события обновления таймера */
export function attachTimerMessageReceivedEvent({ setAvailableTime, setElapsedTime, setNotification, setTimerConfig, voxCall }: Params) {
    voxCall.on(VOXLib.CallEvents.MessageReceived, ({ text }: { text: string }) => {
        const { elapsedTime, remaining, timerLevels, warning } = JSON.parse(text) as ParsedTimerMessage;

        if (remaining !== undefined) {
            // обновляем доступное время конференции
            setAvailableTime(remaining);

            // время конференции подошло к одной из первых ступеней
            if (warning) {
                setNotification(remaining);
            }
        }

        // установка конфигурации таймера
        if (timerLevels !== undefined) setTimerConfig(timerLevels);

        // обновляем текущую длительность конференции
        if (elapsedTime !== undefined) setElapsedTime(elapsedTime);
    });
}
